import styled from '@emotion/styled'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { Flex } from '../atoms/Basics'
import leftQuote from '../../assets/svgs/leftQuote.svg'
import rightQuote from '../../assets/svgs/rightQuote.svg'

const StyledDiv = styled.div`
  max-width: ${(props) => props.theme.widths[0]};
  margin: 0 auto;
  line-height: 1.65;
  color: ${(props) => props.theme.colors.orange};
  font-family: ${(props) => props.theme.fonts.title};
  padding: 1rem 0;
  text-align: right;
  ${Mq.xs} {
    padding: 2rem 0 1rem 0;
  }

  p {
    font-size: 1.7rem;
    margin: 1.25rem 0;
    font-weight: 300;
    ${Mq.xs} {
      font-size: ${(props) => props.theme.fontSizes[3]};
    }
    &.source {
      font-size: ${(props) => props.theme.fontSizes[4]};
      font-weight: 700;
      ${Mq.xs} {
        font-size: ${(props) => props.theme.fontSizes[2]};
      }
    }
  }
`
const TopLine = styled.div`
  border-bottom: 2px solid ${(props) => props.theme.colors.orange};
  padding: 1rem 0 0;
  width: 100%;
`
const BottomLine = styled.div`
  border-top: 2px solid ${(props) => props.theme.colors.orange};
  padding: 1rem 0 0;
  width: 100%;
`
const Quote = ({ quote }) => {
  return (
    <StyledDiv>
      <Flex alignItems="center">
        <img alt="quote" src={leftQuote} />
        <TopLine />
      </Flex>
      <p>{quote?.quote}</p>
      <p className="source">{quote?.source}</p>
      <Flex alignItems="center">
        <BottomLine />
        <img alt="quote" src={rightQuote} />
      </Flex>
    </StyledDiv>
  )
}

export default Quote
